import React, { useEffect, useState } from "react";
import { adminStats } from "@/lib/adminApi";

const fmt = (n) => "€" + Number(n || 0).toFixed(2).replace(".", ",");

const CARDS = [
  { key: "revenue", label: "Chiffre d'affaires", money: true },
  { key: "orders_paid", label: "Commandes payées" },
  { key: "products", label: "Produits" },
  { key: "newsletter", label: "Abonnés newsletter" },
  { key: "orders_total", label: "Commandes totales" },
  { key: "contacts", label: "Messages reçus" },
  { key: "promo_codes", label: "Codes promo" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { adminStats().then(setStats).catch(() => {}); }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="admin-title" style={{ marginBottom: "1.5rem" }}>Tableau de bord</h1>
      {!stats ? (
        <div className="adm-loader"><div className="spinner" /></div>
      ) : (
        <div className="stat-cards" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
          {CARDS.map((c) => (
            <div className="stat-card" key={c.key}>
              <div className="label">{c.label}</div>
              <div className="value">{c.money ? fmt(stats[c.key]) : (stats[c.key] ?? 0)}</div>
            </div>
          ))}
        </div>
      )}
      <p className="adm-hint" style={{ marginTop: "1rem" }}>
        Gérez vos produits, promotions, articles de blog et le contenu du site depuis le menu latéral.
      </p>
    </div>
  );
}
